export const ICE_BASE_API_URL = 'https://gopesa-api.icirena.ai/sync';
